import { observer } from 'mobx-react-lite';
import * as React from 'react';

import {
    HEADER_BUTTONS_REGION_ID,
    OWA_TITLE_BAR_ID,
    WINDOW_ICON_HOST_ID,
} from 'owa-header-constants';
import {
    SEARCH_SCOPE_SWITCHER_WRAPPER_ID,
    SEARCHBOX_COLUMN_CONTAINER_ID,
} from 'owa-search-constants';
import { useUpdateFrame } from 'owa-native-messaging';

import { WindowIconHost } from './WindowIconHost';
import type { OneOutlookSuiteHeaderProps } from './OneOutlookSuiteHeaderProps';
import getIsWindowMaximized from '../selectors/getIsWindowMaximized';

import styles from './OneOutlookSuiteHeader.scss';

const mainWindowExcludedIds = [
    'O365_MainLink_Affordance',
    'O365_HeaderLeftRegion',
    SEARCH_SCOPE_SWITCHER_WRAPPER_ID,
    SEARCHBOX_COLUMN_CONTAINER_ID,
    HEADER_BUTTONS_REGION_ID,
    'O365_HeaderRightRegion',
    WINDOW_ICON_HOST_ID,
];

const projectionWindowExcludedIds = [WINDOW_ICON_HOST_ID];

export default observer(function OneOutlookSuiteHeader(props: OneOutlookSuiteHeaderProps) {
    const titleBarRef = React.useRef<HTMLElement>(null);
    // Create and initialize resize observers.
    // This will only happen once, as subscribe will no-op on subsequent calls.
    const excludedIds = !!props.windowId ? projectionWindowExcludedIds : mainWindowExcludedIds;
    const titleBarId = !!props.windowId
        ? `${OWA_TITLE_BAR_ID}-${props.windowId}`
        : OWA_TITLE_BAR_ID;
    useUpdateFrame(titleBarRef, excludedIds, props.windowId, props.window);

    return (
        <div id={titleBarId} ref={ref => (titleBarRef.current = ref)}>
            <div className={styles.suiteHeaderHost} tabIndex={-1}>
                {props.suiteHeader}
            </div>
            <WindowIconHost
                windowId={props.windowId}
                isMaximized={getIsWindowMaximized(props.windowId)}
            />
        </div>
    );
});
